module.exports = __webpack_public_path__ + "static/media/badge-usage-ad.186df8d5.png";